import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Breadcrumb,
  Card,
  Tag,
  Typography,
  Space,
  Image,
  Descriptions,
  Spin,
  List,
  Button,
} from "antd";
import {
  HomeOutlined,
  CalendarOutlined,
  ApartmentOutlined,
  BookOutlined,
  ArrowLeftOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { formatDate } from "../../../utils/DateTime";
import { useHttp } from "../../../utils/DataHendler";
import { UserContext } from "../../../context/User.context";

const { Title, Paragraph, Text } = Typography;

export const DetailJob = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const { getData } = useHttp();
  const { user } = useContext(UserContext);

  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDetail();
  }, [user, code]);

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const res = await getData(`/job/${code}`, {}, true);
      setDetailData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !detailData) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

 
  const handleEdit = () => {
    navigate(`/user/job-edit/${code}`);
  };


  return (
    <div style={{ padding: 20 }}>
      {/* Breadcrumb */}
      {/* Header */}
      <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        marginBottom: 20,
        padding: "12px 0",
        borderBottom: "1px solid #e8e8e8"
      }}>
        <div style={{ 
          display: "flex",
          alignItems: "center"
        }}>
          <Breadcrumb 
            separator="/"
            style={{ 
              margin: 0,
              fontSize: "14px"
            }}
          >
            <Breadcrumb.Item>
              <a 
                onClick={() => navigate("/user")}
                style={{ 
                  // color: "#1679AB",
                  textDecoration: "none",
                  cursor: "pointer"
                }}
              >
                Job List
              </a>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: "#666" }}>
              Detail Job
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        
        <div>
          <Button 
            type="primary" 
            icon={<EditOutlined />} 
            onClick={handleEdit}
            style={{ 
              borderRadius: "4px",
              height: "32px",
              fontSize: "14px",
              fontWeight: "400",
              // backgroundColor: "#d32f2f",
              // borderColor: "#d32f2f",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            Edit Job
          </Button>
        </div>
      </div>

      {/* Job Card */}
      <Card bordered style={{ borderRadius: 12, overflow: "hidden" }}>
        {/* Image */}
        <Image
          src={detailData.image_url}
          alt={detailData.title}
          width="100%"
          height={300}
          style={{ objectFit: "cover", borderRadius: 8 }}
        />

        {/* Title & Meta */}
        <Title level={3} style={{ marginTop: 20 }}>
          {detailData.title}
          {/* <Tag color="blue">{detailData.code}</Tag> */}
        </Title>
        <Paragraph type="secondary">
          <CalendarOutlined /> Created at: {formatDate(detailData.created_at)}
        </Paragraph>

        {/* Descriptions */}
        <Descriptions
          column={1}
          bordered
          size="middle"
          style={{ marginTop: 20, textAlign: "left" }}
        >
          <Descriptions.Item label="Department">
            <Space>
              <ApartmentOutlined /> {detailData.department_name}{" "}
              {/* <Tag>{detailData.department_code}</Tag> */}
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="Job Category">
            <Space>
              <BookOutlined /> {detailData.job_category_name}{" "}
              {/* <Tag>{detailData.job_category_code}</Tag> */}
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="Description">
            {detailData.description || "-"}
          </Descriptions.Item>
        </Descriptions>

        {/* Requirements */}
        <div style={{ marginTop: 20, textAlign: "left" }}>
          <Title level={5}>Requirements</Title>
          <List
            dataSource={detailData.requirement}
            renderItem={(req) => (
              <List.Item>
                {/* <Tag color="purple">{req}</Tag> */}
                <div>{req}</div>
              </List.Item>
            )}
          />
        </div>
      </Card>
    </div>
  );
};
